/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type useUserBrandsQueryVariables = {};
export type useUserBrandsQueryResponse = {
    readonly currentUser: {
        readonly id: string;
        readonly brandSet: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly name: string;
                } | null;
            } | null>;
        } | null;
    } | null;
};
export type useUserBrandsQuery = {
    readonly response: useUserBrandsQueryResponse;
    readonly variables: useUserBrandsQueryVariables;
};



/*
query useUserBrandsQuery {
  currentUser {
    id
    brandSet {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserNode",
    "kind": "LinkedField",
    "name": "currentUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "BrandNodeConnection",
        "kind": "LinkedField",
        "name": "brandSet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserBrandsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useUserBrandsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "10eb1c2d6fac7644061732d2626a92f1",
    "id": null,
    "metadata": {},
    "name": "useUserBrandsQuery",
    "operationKind": "query",
    "text": "query useUserBrandsQuery {\n  currentUser {\n    id\n    brandSet {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '001394ca359af26b03462f764398a3d9';
export default node;
